import {
  Component,
  OnInit,
  AfterViewInit,
  ChangeDetectionStrategy,
  ElementRef,
  ViewChild,
  signal
} from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageUtils } from '../../classes/messageutils';
import { ChatAdminService } from '../../services/chat-admin.service';
import { MessageEx } from '../../classes/messageex';
import { ContentTypes } from '../../classes/constants';
import { IChatInfoAttachmentEx } from '../../interfaces/chat-info-interfaces';
import { LocationService } from '../../services/location.service';
import { Subject } from 'rxjs';
import { PrimeThemeService } from '../../themes/prime-theme.service';

@Component({
  selector: 'lib-chat-confirmation-dialog',
  templateUrl: './chat-confirmation-dialog.component.html',
  styleUrls: ['./chat-confirmation-dialog.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatConfirmationDialogComponent implements OnInit, AfterViewInit {
  public contentTypes = ContentTypes;
  private ngUnsubscribe: Subject<void> = new Subject();

  @ViewChild('cancelButton') cancelButton: ElementRef<HTMLButtonElement>;

  // Internal signal state - all properties set from dialogConfig.data
  title = signal<string>('');
  item = signal<MessageEx | undefined>(undefined);
  maxImageSize = signal<number | undefined>(undefined);
  dateTimeLocale = signal<string | undefined>(undefined);
  file = signal<IChatInfoAttachmentEx | undefined>(undefined);
  currentLocation = signal<any>(undefined);
  bodyText = signal<string | undefined>(undefined);
  okButtonText = signal<string | undefined>(undefined);
  cancelButtonText = signal<string | undefined>(undefined);

  constructor(
    private dialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig,
    public chatAdminService: ChatAdminService,
    public locationService: LocationService,
    public primeThemeService: PrimeThemeService
  ) {}

  get currentTheme() {
    return this.primeThemeService.currentTheme();
  }

  ngOnInit() {
    // Get data from dialog config
    if (this.dialogConfig.data) {
      this.title.set(this.dialogConfig.data.title);
      this.item.set(this.dialogConfig.data.item);
      this.maxImageSize.set(this.dialogConfig.data.maxImageSize);
      this.dateTimeLocale.set(this.dialogConfig.data.dateTimeLocale);
      this.file.set(this.dialogConfig.data.file);
      this.currentLocation.set(this.dialogConfig.data.currentLocation);
      this.bodyText.set(this.dialogConfig.data.bodyText);
      this.okButtonText.set(this.dialogConfig.data.okButtonText);
      this.cancelButtonText.set(this.dialogConfig.data.cancelButtonText);
    }
  }

  ngAfterViewInit() {
    // PrimeNG's own focusOnShow would focus the first focusable element (the header close
    // button), which doesn't satisfy WCAG 3.3.4's "Cancel button or dialog title" requirement.
    // Callers pass focusOnShow: false and rely on this instead.
    setTimeout(() => this.cancelButton?.nativeElement?.focus(), 0);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  okClick() {
    this.dialogRef.close(true);
  }

  cancelClick() {
    this.dialogRef.close(false);
  }

  getAttachmentDisplayName(attachment): string {
    return MessageUtils.getAttachmentDisplayName(attachment);
  }
}
